import { render } from "./FacultyDetail.vue?vue&type=template&id=bb2f2940&scoped=true"
import script from "./FacultyDetail.vue?vue&type=script&lang=js"
export * from "./FacultyDetail.vue?vue&type=script&lang=js"

import "./FacultyDetail.vue?vue&type=style&index=0&id=bb2f2940&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-bb2f2940"

export default script